export default __webpack_public_path__ + "static/media/service1.0557fbc4.png";